export function share() {
  const button = document.querySelector('a.copy-link');

  if (button) {
    const wrapper = button.closest('ul');

    function copyContent() {
      if (wrapper) wrapper.style.overflow = 'visible';
      const text = button.getAttribute('data-clipboard-text');
      const textSuccess = button.querySelector('.confirmation-text');

      if (textSuccess) {
        textSuccess.classList.add('show');
        textSuccess.focus();
      }

      navigator.clipboard.writeText(text);

      setTimeout(() => {
        if (textSuccess) textSuccess.classList.remove('show');
        if (wrapper) wrapper.style.overflow = 'hidden';
      }, 2000);
    }

    button.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        copyContent();
      }
    });

    button.addEventListener('click', () => {
      copyContent();
    });
  }
}
